export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/fr-ca.lyaml"));
at({});
};